import { Stack } from '@mui/material'
import { ShiftOptions } from 'models/ICattlesData'
import { FC, useEffect } from 'react'
import BreadCrumbsGroup from 'ui/breadCrumbs/BreadCrumbsGroup'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'
import { DateRestriction } from 'ui/DatePickerInput/types'
import { useDateRangeFilter } from '../../hooks/useDateRangeFilter'
import { useMilkingParlorFilters } from '../../hooks/useMilkingParlorFilters'
import { useShiftFilters } from '../../hooks/useShiftFilters'
import { IMilkingProcessFilters } from '../../types'

type MilkingProcessHeaderProps = {
	onFiltersChange: (filters: IMilkingProcessFilters) => void
	nullShifts?: ShiftOptions[]
}

export const MilkingProcessHeader: FC<MilkingProcessHeaderProps> = ({
	onFiltersChange,
	nullShifts = [],
}) => {
	const {
		handleToggleParlor,
		handleRemoveParlor,
		availableParlors,
		parlorBreadcrumbs,
		parlorId,
	} = useMilkingParlorFilters()

	const {
		handleToggleShift,
		handleRemoveShift,
		availableShifts,
		shiftBreadcrumbs,
		shift,
	} = useShiftFilters(nullShifts)

	const { dateRange, onChangeCallback, daysBetweenDates } = useDateRangeFilter()

	useEffect(() => {
		onFiltersChange({ parlorId, shift, dateRange, daysBetweenDates })
	}, [parlorId, shift, dateRange, daysBetweenDates, onFiltersChange])

	return (
		<Stack
			direction={'row'}
			justifyContent={'space-between'}
			alignItems={'end'}
			gap={'24px'}
			sx={{ width: '100%' }}
		>
			<Stack direction={'column'} gap={'12px'}>
				{availableParlors.length > 1 && (
					<BreadCrumbsGroup
						handleActiveFilter={handleToggleParlor}
						handleRemoveFilter={handleRemoveParlor}
						array={parlorBreadcrumbs}
					/>
				)}
				{availableShifts.length > 0 && (
					<BreadCrumbsGroup
						handleActiveFilter={handleToggleShift}
						handleRemoveFilter={handleRemoveShift}
						array={shiftBreadcrumbs}
					/>
				)}
			</Stack>
			<DateRangePicker
				onChangeUpdateDate={onChangeCallback}
				startDate={dateRange.startDate}
				endDate={dateRange.endDate}
				restrictionType={DateRestriction.PAST}
				currentRange={'Сегодня'}
				isShowResetBtn={true}
				resetButtonPosition='left'
			/>
		</Stack>
	)
}
